export default __webpack_public_path__ + "static/media/6-1-fillAssessmentSubmissionDetails.571ced48.png";